module.exports = __webpack_public_path__ + "static/media/junctionx_asia_white_twoline.be091edb.png";